export default {
    data() {
        return {
            current_plan
        };
    },

    methods: {
        hasPlan(plan) {
            return this.current_plan.number >= plan;
        },
    },
};
